import { ActivatedRouteSnapshot, Route } from '@angular/router';
import { inject } from '@angular/core';
import { ServiceCategoryService } from '@app/src/app/modules/service/service/service.category.service';
import { ServiceService } from '@app/src/app/modules/service/service/service.service';
import { ServiceCategoryGuard } from '@app/src/app/modules/service/classes/category/guard/service-category-guard';
import { ServiceGuard } from '@app/src/app/modules/service/classes/default/guard/service-guard';

export default {
  path: 'services',
  data: {
    titlePrefix: 'Services',
  },
  children: [
    {
      path: ':category',
      children: [
        {
          path: '',
          loadComponent: () =>
            import('@app/src/app/modules/service/views/public/category/category-services-list/category-services-list').then(
              (m) => m.CategoryServicesList,
            ),
          resolve: {
            item: (route: ActivatedRouteSnapshot) =>
              Promise.resolve(
                inject(ServiceCategoryService).fetchBySlug(
                  route.paramMap.get('category'),
                ),
              ),
          },
          canActivate: [ServiceCategoryGuard()],
        },
        {
          path: ':service',
          loadComponent: () =>
            import('@app/src/app/modules/service/views/public/default/service-item/service-item').then(
              (m) => m.ServiceItem,
            ),
          resolve: {
            item: (route: ActivatedRouteSnapshot) =>
              inject(ServiceService).fetchBySlug(
                route.paramMap.get('service'),
                route.paramMap.get('category'),
              ),
          },
          canActivate: [ServiceGuard()],
        },
      ],
    },
  ],
} as Route;
